module.exports = __webpack_public_path__ + "resources/img/1@3x.e5a487c3.png";